import React from 'react';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { FDStack } from '@facet-wealth/design';
import { FrequentlyAskedQuestionsAccordion } from './FrequentlyAskedQuestionsAccordion';
import { FrequentlyAskedQuestionsTitle } from './FrequentlyAskedQuestionsTitle';
import { FrequentlyAskedQuestionsSubtitle } from './FrequentlyAskedQuestionsSubtitle';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FrequentlyAskedQuestionsTitle,
    _customProps: { color: 'textSecondary' },
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => FrequentlyAskedQuestionsSubtitle,
  }, overrideReadOnly);

export const FrequentlyAskedQuestionsContent = ({ collection }) => {
  if (collection.resources().length() === 0) {
    return null;
  }

  const [faqResource] = collection;

  return (
    <FDStack
      direction={'column'}
      spacing={2}
    >
      <MetaControl resource={faqResource} attrName={'title'} metaOverrideSet={metaOverrideSet} />
      {faqResource.meta().field('subtitle').isEmpty() ? null : <MetaControl resource={faqResource} attrName={'subtitle'} metaOverrideSet={metaOverrideSet} />}
      <FrequentlyAskedQuestionsAccordion metaOverrideSet={metaOverrideSet} faqResource={faqResource} />
    </FDStack>
  );
};
